import { Employee, PayPeriod } from "./gql/types";

const baseProps = {
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  middleInitial: "",
  phone: "",
  payPeriod: PayPeriod.Weekly,
};

export const employees: Employee[] = [
  {
    ...baseProps,
    firstName: "Joe",
    isMobileEmployee: true,
    isTerminated: false,
    lastName: "Bob",
    ultiProId: "ABC123",
    userPrincipalName: "joe@topographic.com",
    email: "joe@topographic.com",
    workLocation: "CE",
    timeEntryMethod: "Workflow",
  },
  {
    ...baseProps,
    firstName: "Sally",
    isMobileEmployee: true,
    isTerminated: false,
    lastName: "Field",
    ultiProId: "DEF456",
    userPrincipalName: "sally@topographic.com",
    email: "sally@topographic.com",
    workLocation: "OK",
    timeEntryMethod: "Workflow",
  },
  {
    ...baseProps,
    firstName: "Ricky",
    isMobileEmployee: false,
    isTerminated: true,
    lastName: "Ricardo",
    ultiProId: "GHI789",
    userPrincipalName: "ricky@topographic.com",
    email: "ricky@topographic.com",
    workLocation: "NM",
    timeEntryMethod: "Workflow",
  },
  {
    ...baseProps,
    firstName: "Tamika",
    isMobileEmployee: true,
    isTerminated: false,
    lastName: "Brown",
    ultiProId: "JKL321",
    userPrincipalName: "tamika@topographic.com",
    email: "tamika@topographic.com",
    workLocation: "MI",
    timeEntryMethod: "Workflow",
  },
  {
    ...baseProps,
    firstName: "Test",
    isMobileEmployee: true,
    isTerminated: false,
    lastName: "User",
    ultiProId: "MNO654",
    userPrincipalName: "testuser@topographic.com",
    email: "testuser@topographic.com",
    workLocation: "MI",
    timeEntryMethod: "Workflow",
  },
];
